export const colors = {
    blueButton: '#002B59',
    whitefont: '#FFFFFF',
    IconBlue: '#5FBDD6',
    backgroundBlue:'#F0FBFE',
 
  };